import { createStore } from 'vuex'
import ApiService from "../services"
import axios from 'axios';
export default createStore({
    state: {
        myChars: null,
        myGuns: null,
        stakes: { "bankrobbery": { locked: false }, "advanture": { locked: false }, "stagecoach": { locked: false }, "sherifraid": { locked: false } },
        inventory: [],
        resources: [],
        loaded: false,
        balance: 0,
        walletBalance: 0,
        weapons: null,
        selectedGun: null,
        market: null,
        selectedChars: [],
        selectedCharsIds: [],
        gameItems: [],
    },
    actions: {
        fetchInventory:function({commit},schema){
            ApiService.getInventory((res) => {
                let inventory = res.filter((i) => i.value.schema == schema);
                inventory.map(async (item, i) => {
                    inventory[i].value.locked = ApiService.isExpired(
                        item.value.lock_end
                    );
                });
                commit("addInventory", inventory);
            });
        },
        getBalance: function({ commit }) {
            return axios
                .post(`${process.env.VUE_APP_CHAIN_API}/get_account`, { account_name: localStorage.getItem("wax_user") })
                .then((res) => {
                    commit("addBalance", res.data.core_liquid_balance);
                })
        },
    },
    mutations: {
        addWeapons: (state, payload) => {
            if (payload) {
                return state.weapons = payload;
            }
        },
        addGameItems: (state, payload) => {
            if (payload) {
                return state.gameItems = payload;
            }
        },
        addInventory: (state, payload) => {
            if (payload) {
                return state.inventory = payload;
            }
        },
        addResources: (state, payload) => {
            if (payload) {
                return state.resources = payload;
            }
        },
        addMarket: (state, payload) => {
            if (payload) {
                return state.market = payload;
            }
        },
        addChars: (state, payload) => {
            if (payload) {
                return state.myChars = payload;
            }
        },
        addGuns: (state, payload) => {
            if (payload) {
                return state.myGuns = payload;
            }
        },
        addBalance: (state, payload) => {
            if (payload) {
                return state.balance = payload;
            }
        },
        addStake: (state, payload) => {
            if (payload) {
                return state.stakes = payload;
            }
        },
        addWalletBal: (state, payload) => {
            if (payload) {
                return state.walletBalance = payload;
            }
        },
        isLoaded: (state, payload) => {
            state.loaded = payload;
        },
        addCard(state, val) {
            state.selectedCard = val.value;
            state.selectedCard.asset_id = val.key;
            if (state.selectedCard.schema == "guns") {
                state.selectedGun = val.value;
                state.selectedGun.asset_id = val.key;
            } else {
                // if (state.selectedChars.length < 3) {
                //     state.selectedChars.push(state.selectedCard)
                //     state.selectedCharsIds.push(state.selectedCard.asset_id)
                // }else{
                //     state.selectedChars[2]=state.selectedCard;
                //     state.selectedCharsIds[2]=state.selectedCard.asset_id;
                // }
                if (state.selectedCharsIds.length < 3) {
                    state.selectedChars.push(state.selectedCard)
                    state.selectedCharsIds.push(state.selectedCard.asset_id)
                }else{
                    state.selectedChars[2]=state.selectedCard;
                    state.selectedCharsIds[2]=state.selectedCard.asset_id;
                }
            }
        },
        rmCard(state, val) {
            let selectedCard = val.value;
            selectedCard.asset_id = val.key;
            if(val.value.schema=="guns"){
                state.selectedGun=null;
            }else{
                let chars = state.selectedChars;
                let itemIndex = state.selectedChars.findIndex(el => el.asset_id ==val.key);
                chars.splice(itemIndex,1);
                state.selectedChars = [];
                setTimeout(() => {
                    state.selectedChars = chars;
                    state.selectedCharsIds.splice(itemIndex, 1);
                }, 100);
            }
        },
        rmCharacter(state, val) {
            state.selectedChars=val
        },
        clearSelectedCards(state) {
            state.selectedGun=null;
            state.selectedChars=[];
            state.selectedCharsIds=[];
        },
    },
    getters: {
        wwgTokenWallet: state => {
            if (state.walletBalance) {
                return state.walletBalance.filter((row) => row.includes("WWG"))[0];
            }
            return 0;
        },
        wwsTokenWallet: state => {
            if (state.walletBalance) {
                return state.walletBalance.filter((row) => row.includes("WWS"))[0];
            }
            return 0;
        },
        wwsToken: state => {
            if (state.balance) {
                let val = state.balance.filter((row) => row.key == "4,WWS");
                if (val[0]) {
                    return val[0].value / 10000;
                }
            }
            return 0;
        },
        wwgToken: state => {
            if (state.balance) {
                let val = state.balance.filter((row) => row.key == "4,WWG");
                console.log(val);
                if (val[0]) {
                    return val[0].value / 10000;
                }
            }
            return 0;
        },
        foods: state => {
            if (state.gameItems.length) {
                let food = ["1,BEANS", "1,CBREAD", "1,JERKY","1,FSTEW"];
                return state.gameItems.filter((row) => food.includes(row.key));
            }
            return [];
        },
        totalGameItems: state => {
            if (state.gameItems.length) {
                let food = ["1,BEANS", "1,CBREAD", "1,JERKY", "1,FSTEW"];
                let items = state.gameItems.filter((row) => !food.includes(row.key));
                return items.reduce((partialSum, a) => partialSum + a.value, 0);
            }
            return [];
        },
        totalFood: state => {
            if (state.gameItems.length) {
                let foods = ["1,BEANS", "1,CBREAD", "1,JERKY", "1,FSTEW"];
                let food = state.gameItems.filter((row) => foods.includes(row.key));
                return food.reduce((partialSum, a) => partialSum + a.value, 0);
            }
            return [];
        },
        totalDynamites: state => {
            return state.resources.length;
        },
        gameItems: state => state.gameItems,
        myGuns: state => state.myGuns,
        myChars: state => state.myChars,
        stakes: state => state.stakes,
        loaded: state => state.loaded,
        selectedChars: state => state.selectedChars,
        selectedCharsIds: state => state.selectedCharsIds,
        selectedGun: state => state.selectedGun,
        balance: state => state.balance,
        walletBalance: state => state.walletBalance,
        inventory: state => state.inventory,
        resources: state => state.resources,
    }
})